// ** Third Party Imports
import styled from 'styled-components'

// ** Component Imports
import { Heading, Button, ChipsInput, InputField } from '@/shared/ui'

// ** Icons Imports
import { Plus, Link, CopyLeft } from '@/shared/ui/icons'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 1rem;
`

export const PlusIcon = styled(Plus)`
	path {
		fill: ${({ theme }) => theme.pallette.geniiWhite};
	}
`

export const LinkIcon = styled(Link)<{ $isError: boolean }>`
	path {
		stroke: ${({ theme, $isError }) =>
			$isError
				? theme.pallette.text.black50
				: theme.pallette.success.main} !important;
	}
	top: 1rem;
	left: 0.75rem;
	width: 1rem;
	height: 1rem;
	position: absolute;
`

export const CopyIcon = styled(CopyLeft)<{ $isError: boolean }>`
	path {
		stroke: ${({ theme, $isError }) =>
			$isError
				? theme.pallette.text.black50
				: theme.pallette.success.main} !important;
	}
	top: 1rem;
	right: 0.75rem;
	width: 1rem;
	height: 1rem;
	position: absolute;
	cursor: pointer;
`

export const StyledHeading = styled(Heading)`
	align-self: center;
	margin-top: -1rem;
`

export const EmailInputContainer = styled.div`
	display: flex;
	column-gap: 0.75rem;
`

export const StyledChipsInput = styled(ChipsInput)`
	flex: 1;
`

export const InviteButton = styled(Button)`
	align-self: center;
`

export const StyledInputField = styled(InputField)`
	padding-right: 2.5rem;
	text-overflow: ellipsis;
`

export const StateWrapper = styled.div`
	display: flex;
	align-items: center;
	padding-bottom: 2rem;
	justify-content: center;
`
